var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgApple(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    rx: 13,
    fill: "#121416"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_305_19421)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.3572 13.4539C17.3796 15.7195 19.4768 16.4735 19.5 16.4831C19.4823 16.5363 19.1649 17.5575 18.3951 18.6124C17.7297 19.5245 17.0391 20.4332 15.9511 20.452C14.8821 20.4704 14.5383 19.8575 13.3161 19.8575C12.0943 19.8575 11.7123 20.4332 10.7004 20.4704C9.65022 20.5077 8.85053 19.4842 8.17956 18.5755C6.80851 16.7168 5.76075 13.3232 7.16763 11.0324C7.86654 9.8948 9.11554 9.17443 10.4712 9.15596C11.5025 9.13751 12.4758 9.80653 13.1062 9.80653C13.7362 9.80653 14.9191 9.00198 16.1625 9.12014C16.6831 9.14045 18.1443 9.31732 19.0826 10.6052C19.007 10.6492 17.3391 11.5597 17.3572 13.4539ZM15.3481 7.89041C15.9056 7.25756 16.2809 6.37658 16.1785 5.5C15.3749 5.53029 14.4031 6.00218 13.8266 6.63468C13.31 7.19479 12.8576 8.09129 12.9797 8.95051C13.8754 9.0155 14.7905 8.52367 15.3481 7.89041Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_305_19421"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13,
    height: 15,
    fill: "white",
    transform: "translate(6.5 5.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApple);
export default __webpack_public_path__ + "static/media/apple.e9e08b5e82c7b6e0f253491f5cdc375c.svg";
export { ForwardRef as ReactComponent };